import Icon from '@chakra-ui/icon';
import { Flex, Heading, Link, Text } from '@chakra-ui/layout';
import moment from 'moment';
import React from 'react';
import { Play } from 'react-feather';
import { FirebaseConfig, FirebaseCourseItem } from '../../../types/types';
import { isShortlyBeforeCourse } from '../../../utils/isShortlyBeforeCourse';
import { shadeColor } from '../../../utils/shadeColor';

const stringToColour = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    // eslint-disable-next-line no-bitwise
    const value = (hash >> (i * 8)) & 0xff;
    colour += `00${value.toString(16)}`.substr(-2);
  }
  return colour;
};

interface CourseItemProps {
  course: FirebaseCourseItem;
  config: FirebaseConfig | null;
  target?: string;
}

export const CourseItem: React.FC<CourseItemProps> = ({
  course,
  config,
  target,
}) => (
  <Flex
    direction="column"
    borderRadius="xl"
    mb={2}
    p={2}
    bg="gray.100"
    overflow="hidden"
    transition="all ease .5s"
    _hover={{
      boxShadow: 'md',
      transform: 'scale(1.02)',
    }}
  >
    <Flex
      direction="column"
      as="a"
      target={target}
      href={`${window.location.origin}/upcoming-courses`}
    >
      <Heading
        mb={1}
        color={`${shadeColor(stringToColour(course.title), -100)}`}
        size="sm"
        textOverflow="ellipsis"
      >
        {course.title}
      </Heading>

      <Text>
        {moment(course.startMoment).format('HH:mm')} -{' '}
        {moment(course.endMoment).format('HH:mm')}
      </Text>

      {course.trainer.ids[0] && <Text>mit {course.trainer.ids[0]}</Text>}
    </Flex>

    {course.isOnline && isShortlyBeforeCourse(course, config!) && (
      <Link
        mt={2}
        lineHeight="1em"
        fontWeight="bold"
        alignSelf="flex-end"
        target={target}
        href={`${window.location.origin}/public-course/${
          course.uid
        }/${encodeURIComponent(course.title)}`}
      >
        <Icon lineHeight="1em" as={Play} boxSize="0.7em" /> Online-Kurs
      </Link>
    )}
  </Flex>
);
